<template>
  <div class="">
    <div class="container">
      <h2 class="header-font text-center">About the instructor</h2>
      <div class="grid">
        <div class="img">
          <img
            src="../../assets/DataScience/Group 19.png"
            alt=""
            style="background-color: #FBBF05;border-radius:50%"
          />
        </div>
        <div class="text">
          <h3>
            Khan Muhammad Saqiful Alam
          </h3>
          <ul>
            <li>
              Program Manager, Trust and Safety, South Asia Region, TikTok
            </li>
            <li>Analytics Adviser, Intelligent Machines Limited</li>
            <li>Analytics Adviser, Upskill</li>
            <li>
              Trainer in Analytics and have so far trained around 500
              Professionals
            </li>
            <li>
              Guest Lecturer for Business Analytics course in IBA, DU (The first
              full-fledged business analytics course for undergraduate students)
            </li>
          </ul>
          <div>
            <button @click="red" class="btn-1" ref="btnToggle">
              Show More
            </button>
            <span v-if="readmore">
              <h2 class="span-h2">
                Khan Muhammad Saqiful Alam, Program Manager, Trust and Safety,
                South Asia Region, TikTok
              </h2>
              <h4 class="span-h4">
                Saqif is at present working in the Trust and Safety zone in
                TikTok, looking after the South Asia Markets. Besides that he is
                also a Commonwealth Scholar in National University of Singapore
                (NUS). His area of research is in Innovation and Application of
                Machine Learning in Business Strategy. Besides this, he is an
                analytics adviser of Intelligent Machines Limited (a company
                working with machine learning and big data) and Upksill (a
                professional training and certification platform), and works on
                several other strategic and analytics consultancy projects. He
                is also a professional trainer for Light Castle Partners,
                Upskill, GP Accelerator and NUS Executive Education School, and
                the community manager for Google Business Groups Sonargaon. He
                did his MSc in Operations and Risk Management from University of
                Manchester and did his BBA from IBA, Dhaka University. His
                consulting and work areas of focus are – data-driven decision
                making, application of machine learning in businesses, helping
                businesses be strategically data driven, strategic risk
                management and simulations. He also specializes in startup
                scaling up and strategic planning.
              </h4>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      readmore: false,
    }
  },
  methods: {
    red() {
      this.readmore = !this.readmore
      this.$refs.btnToggle.innerText = this.readmore ? 'Hide More' : 'Show More'
    },
  },
}
</script>

<style scoped>
.btn-1 {
  background-color: white;
  border: none;
  color: #2465f3;
  padding: 7px 30px;
  cursor: pointer;
  font-size: 16px;
  font-family: 'Manrope';
  font-weight: 700;
}
.span-h2 {
  padding-top: 20px;
  font: 700 0.875rem/1rem 'Manrope';
  color: white;
}
.span-h4 {
  padding: 20px 0;
  font: 400 0.75rem/1rem 'Manrope';
  color: white;
}
.img img {
  margin: 65px 130px;
  border: none;
}
.grid {
  max-width: 1300px;
  margin: 0 auto;
  background-color: #184dbd;
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
}
.header-font {
  padding-top: 70px;
  font: 800 2.25rem/2.75rem 'Manrope';
  color: #29292b;
  padding-bottom: 50px;
}
.text {
  padding-top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.text h3 {
  font: 700 1.5rem/1.75rem 'Manrope';
  color: white;
}
ul li {
  font: 400 0.875rem/1rem 'Manrope';
  color: #d7eefd;
}
@media only screen and (max-width: 600px) {
  .img img {
    display: flex;
    margin: 25px auto;
    border: none;
  }
  .grid {
    max-width: 1300px;
    margin: 0 auto;
    background-color: #184dbd;
    display: flex;
    flex-direction: column;
    grid-template-columns: 1fr;
  }
  .text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 20px 40px;
  }
}
</style>
